<template lang="pug">
  div.h-screen.flex.flex-col.justify-center.items-center
    router-link.absolute.top-0.right-0.mr-8.mt-8.z-10(to="/sign-in") Sign in

    div.text-center.flex.flex-col.justify-center.items-center(v-if="!isResetting")
      form.flex.flex-col.items-center.align-center(@submit.prevent="validateEmail" v-if="!emailSent")
        h1.text-5xl.font-semibold.mb-8 Forgot password?
        input.w-64(:class="{error:emailError}" v-model="email" placeholder="Your email address...")
        p.help-text.error-text.w-64(v-if="emailError") {{emailError}}
        button.mt-4.main.w-64.p-4(type="submit") Send me the reset email

      h1.text-5xl.font-semibold.mb-8.max-w-sm(v-else) We sent you an email, check your inbox!

    form.text-center.flex.flex-col.justify-center.items-center(v-else @submit.prevent="validatePassword")
      h1.text-5xl.font-semibold.mb-8 Change password
      input.w-64(:class="{error:passwordError}" type="password" v-model="password" placeholder="Your new password...")
      p.help-text.error-text(v-if="passwordError") {{passwordError}}
      button.mt-4.main.w-64.p-4(type="submit") Save new password
    
    Loader(v-if="isWorking")
</template>

<script>
import CheckBox from "../components/CheckBox";
import Loader from "../components/Loader";
import { ref, onMounted } from "@vue/composition-api";
import { auth } from "../firebase.config";
import { mapActions } from "vuex";

export default {
  name: "SignUp",
  components: { CheckBox, Loader },
  props: ["header", "subheader", "type", "action"],
  methods: { ...mapActions(["signInWithGoogle", "test", "signUpForm"]) },
  setup(props, { root, emit }) {
    const email = ref("");
    const emailError = ref("");
    const disableEmail = ref(false);
    const password = ref("");
    const passwordError = ref("");
    const isResetting = ref(false);
    const isWorking = ref(false);
    const emailSent = ref(false);
    const token = ref("");

    onMounted(() => {
      const linkEmail = root.$route.query.email;
      if (!linkEmail) return;
      else {
        email.value = linkEmail;
        token.value = root.$route.query.token;
        isResetting.value = true;
      }
    });

    async function validateEmail() {
      isWorking.value = true;

      // validate email
      if (!email.value) emailError.value = "You need an email address";
      else {
        const lintedEmail = await root.$store.dispatch(
          "lintEmail",
          email.value
        );
        const isEmail = await root.$store.dispatch("isEmail", lintedEmail);

        if (!isEmail) emailError.value = "That’s not a proper email adress";
        else {
          email.value = lintedEmail;
          emailError.value = "";
        }
      }

      // check if there are any errors before proceeding
      if (emailError.value) return;

      // sign up if no errors
      root.$store.dispatch("sendPasswordResetEmail", email.value).then(() => {
        isWorking.value = false;
        emailSent.value = true;
      });
    }

    async function validatePassword() {
      isWorking.value = true;
      if (password.value.length < 6)
        passwordError.value = "C’mon, at least 6 characters please";
      else passwordError.value = "";

      // check if there are any errors before proceeding
      if (passwordError.value) return;

      root.$store
        .dispatch("setNewPassword", {
          email: email.value,
          password: password.value,
          token: token.value
        })
        .then(() => {
          isWorking.value = false;
          root.$router.push("/sign-in");
        });
    }

    return {
      name,
      email,
      emailError,
      disableEmail,
      password,
      passwordError,
      validateEmail,
      validatePassword,
      isResetting,
      isWorking,
      emailSent
    };
  }
};
</script>
<style lang="sass" scoped></style>
